import { authHeader } from "../_helpers/auth-header";
import { deferredFetch, APIFetchV2 } from "../utils/request";
import { fieldResponseModelCreator } from "../components/WorkflowDetails/utils/modelCreator";
import { apiBaseURL, apiBaseURLV2 } from "@certa/network";

export const workflowStepService = {
  saveField,
  fetchFieldExtra,
  submitStep,
  undoStep,
  removeAttachment
};

function saveField(payload) {
  let requestOptions = {};
  if (payload.attachment) {
    const data = new FormData();
    data.append("workflow", payload.workflow);
    data.append("field", payload.field);
    data.append("attachment", payload.attachment);

    requestOptions = {
      method: "POST",
      headers: {
        ...authHeader.post()
      },
      credentials: "include",
      body: data
    };

    delete requestOptions.headers["Content-Type"];
  } else {
    requestOptions = {
      method: "POST",
      headers: {
        ...authHeader.post(),
        "Content-Type": "application/json"
      },
      credentials: "include",
      body: JSON.stringify(payload)
    };
  }

  return APIFetchV2("responses/", requestOptions)
    .then(handleResponse)
    .then(fieldResponseModelCreator);
}

function removeAttachment(responseId) {
  let requestOptions = {};
  requestOptions = {
    method: "DELETE",
    headers: { ...authHeader.post() },
    credentials: "include"
  };

  return APIFetchV2(`responses/${responseId}/clear/`, requestOptions)
    .then(handleResponse)
    .then(fieldResponseModelCreator);
}

//fetch extra for field
/**
 * @deprecated
 */
function fetchFieldExtra({ url, tag }) {
  if (!url) {
    return Promise.reject('"url" not defined for fetchFieldExtra');
  }
  const requestOptions = {
    method: "GET"
  };
  if (!url.match(/^https?:\/\//)) {
    url = url.includes("api/v2/")
      ? apiBaseURLV2 + url.replace(/\/{0,1}api\/v2\//, "")
      : apiBaseURL + url.replace(/\/{0,1}api\/v1\//, "");
    Object.assign(requestOptions, {
      headers: authHeader.get(),
      credentials: "include"
    });
  }
  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(data => ({ data, tag }));
}

//Save step data on submit
function submitStep(stepId) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader.post(), "Content-Type": "application/json" },
    credentials: "include"
  };

  const url = `steps/${stepId}/submit/`;
  return deferredFetch(url, requestOptions)
    .then(handleResponse)
    .then(response => ({
      completedAt: response.completed_at,
      completedBy: {
        id: response.completed_by.id,
        firstName: response.completed_by.first_name,
        lastName: response.completed_by.last_name,
        email: response.completed_by.email
      },
      canSubmitStep: response.can_submit,
      canUndoStep: response.can_undo
    }));
}

function undoStep(stepId) {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader.post(), "Content-Type": "application/json" },
    credentials: "include"
  };

  return APIFetchV2(`steps/${stepId}/undo/`, requestOptions).then(response => {
    if (!response.ok) {
      return Promise.reject();
    }
    return response;
  });
}

function handleResponse(response) {
  if (!response.ok) {
    return response.json().then(error => {
      return Promise.reject(error);
    });
  }

  return response.json();
}
